import { Box, makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { HorizontalGrid } from '../HorizontalGrid';
import clsx from 'clsx';

export type FieldsetProps = React.PropsWithChildren<{
    icon: React.ReactNode
    title: string
    hasMarginTop?: boolean
    hasContentPadding?: boolean
}>

export function Fieldset ({ icon, title, children, hasMarginTop, hasContentPadding }: FieldsetProps) {
    const cls = useStyles();

    return (
        <Paper variant="outlined" className={clsx({
            [cls.marginTop]: hasMarginTop !== false
        })}>
            <Box className={cls.titleContainer}>
                <HorizontalGrid verticalAlign="center">
                    <Box className={cls.icon}>{ icon }</Box>
                    <Typography>{ title }</Typography>
                </HorizontalGrid>
            </Box>

            <Box className={clsx({
                [cls.content]: hasContentPadding !== false
            })}>
            { children }                
            </Box>
        </Paper>
    )
}

const useStyles = makeStyles(theme => ({
    marginTop: {
        margin: `${theme.spacing(2)}px 0 0 0`,
    },

    titleContainer: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        backgroundColor: 'rgba(0, 0, 0, .05)'
    },

    icon: {
        marginRight: theme.spacing(1)
    },

    content: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    }
}));